(() => {
  if (customElements.get('makage-free-shipping')) return;

  const GOALS = { EUR: 70 };
  const previous = new Map();

  customElements.define(
    'makage-free-shipping',
    class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.render());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.animation);
      }

      render() {
        const currency = this.dataset.currency;
        const total = Number(this.dataset.total);
        const de = this.dataset.language.toLowerCase().startsWith('de');
        const shopifyCurrency = window.Shopify?.currency;

        let goal = GOALS[currency];

        if (
          !goal &&
          this.dataset.shopCurrency === 'EUR' &&
          shopifyCurrency?.active === currency
        ) {
          const rate = Number(shopifyCurrency.rate);

          if (Number.isFinite(rate) && rate > 0) {
            goal = GOALS.EUR * rate;
          }
        }

        const message = this.querySelector('[data-message]');
        const track = this.querySelector('[data-track]');
        const fill = this.querySelector('[data-fill]');

        if (!message || !track || !fill) return;

        if (
          !Number.isFinite(goal) ||
          goal <= 0 ||
          !Number.isFinite(total)
        ) {
          message.textContent = de
            ? 'Kostenloser Versand ab 70 € – Gegenwert in deiner Währung.'
            : 'Free shipping from €70 – equivalent in your currency.';

          track.hidden = true;
          this.hidden = false;
          return;
        }

        const threshold = Math.round(goal * 100);
        const remaining = Math.max(0, threshold - total);

        const percent = Math.max(
          0,
          Math.min(100, total / threshold * 100)
        );

        const formatter = new Intl.NumberFormat(
          this.dataset.language || 'en',
          {
            style: 'currency',
            currency
          }
        );

        const factor =
          10 ** formatter.resolvedOptions().maximumFractionDigits;

        const amount = formatter.format(
          Math.ceil(remaining / 100 * factor) / factor
        );

        message.textContent = remaining === 0
          ? (
              de
                ? 'Kostenloser Versand erreicht!'
                : 'Free shipping reached!'
            )
          : (
              de
                ? `Noch ${amount} bis zum Gratisversand`
                : `${amount} left for free shipping`
            );

        track.hidden = false;

        track.setAttribute(
          'aria-label',
          de
            ? 'Fortschritt zum Gratisversand'
            : 'Free shipping progress'
        );

        track.setAttribute(
          'aria-valuenow',
          String(Math.round(percent))
        );

        track.setAttribute(
          'aria-valuetext',
          message.textContent
        );

        const key =
          `${this.dataset.position || 'drawer'}:${currency}`;

        fill.style.width = `${previous.get(key) ?? 0}%`;
        this.hidden = false;

        void fill.offsetWidth;

        this.animation = requestAnimationFrame(() => {
          fill.style.width = `${percent}%`;
        });

        previous.set(key, percent);
      }
    }
  );
})();